export enum GoalAchievement {
  Completely,
  Partially,
  NotAtAll,
}
